// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// IMPORTANT : Importez le fichier i18n pour initialiser i18next
import './i18n'; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* L'initialisation est faite par l'importation ci-dessus */}
    <App />
  </React.StrictMode>
);

reportWebVitals();